'use client';

import { ReactNode, useEffect, useRef, useState, useTransition } from 'react';

interface Props {
  id: number | string;
  name: string;
  expandedId: string;
  title: string;
  handleChange: (event: string) => void;
  children?: ReactNode;
}

export function Accordion({ id, name, title, expandedId, handleChange, children }: Props) {
  const [isPending, startTransition] = useTransition();
  const [isOnChange, setIsOnChange] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!isPending && isOnChange) {
      setIsOnChange(false);
      ref.current?.scrollIntoView({
        behavior: 'smooth',
      });
    }
  }, [ref, isPending, isOnChange]);

  return (
    <div ref={ref} className="collapse-plus bg-base-200 collapse">
      <input
        className="cursor-pointer!"
        type="checkbox"
        value={id}
        name={name}
        checked={expandedId === id.toString()}
        onChange={(event) => {
          if (event.currentTarget.checked) {
            startTransition(() => handleChange(id.toString()));
            setIsOnChange(true);
          } else {
            startTransition(() => handleChange(''));
          }
        }}
      />
      <div className="collapse-title flex items-center justify-between gap-2 text-xl font-medium">
        {title}
        {isPending && <div className="loading loading-sm" />}
      </div>
      <div className="collapse-content h-full w-full overflow-x-auto overflow-y-hidden">
        {children}
      </div>
    </div>
  );
}
